import "../css/FilterComponent.css";

const SelectInput = ({ label, value, onChange, options }) => {
  const id = `select-${label.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <div className="trip-request-filter-item">
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        value={value}
        onChange={onChange}
        style={{ color: value ? "#000" : "#888" }}
      >
        <option value="" disabled hidden>
          Select
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
